import * as React from 'react'
import Dropdown from 'react-dropdown'
import './style.css'
import { styled } from '$utils/theme'

interface Props extends React.SelectHTMLAttributes<any> {
  className?: string
  options: {
    value: string
    label: string
  }[]
  defaultOption?: any
  placeholder?: string
  inline?: boolean
  width?: number
  onChange?: (value: any) => void
  onFocus?: () => void
  bordered?: boolean
}

const StyledDropdown = styled(Dropdown)<Props>`
  width: ${p => p.width}% !important;
  &:hover {
    cursor: pointer;
  }
  ${p =>
    p.bordered &&
    `
    border-radius: 1.5625rem 1.5625rem;
    border: 1px solid ${p.theme.colors.blue};
  `};
`

export const Select: React.SFC<Props> = props => {
  return (
    <>
      {props.inline && (
        <StyledDropdown
          className="Inline"
          options={props.options}
          value={props.defaultOption}
          onChange={props.onChange}
          placeholder={props.placeholder}
          width={props.width}
          bordered={props.bordered}
          onFocus={props.onFocus}
        />
      )}
      {!props.inline && (
        <Dropdown
          onChange={props.onChange}
          options={props.options}
          value={props.defaultOption}
          placeholder={props.placeholder}
        />
      )}
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Select/Select.tsx